import { useState } from 'react';

import SimpleTooltip from './tooltips/SimpleTooltip';
import TitleTooltip from './tooltips/TitleTooltip';
import StageTooltip from './tooltips/StageTooltip';
import StatusTooltip from './tooltips/StatusTooltip';
import BasicCellText from './tooltips/BasicCellText';

const BulkRevToEvalColumns = (columnWidths) => {
	const [openTooltip, setOpenTooltip] = useState(0);

	return [
		{
			field: 'submitter',
			headerName: 'Submitter',
			renderCell: (cellValues) => <SimpleTooltip cellValues={cellValues} />,
			flex: columnWidths.title || 1,
			resizable: true
		},
		{
			field: 'title',
			headerName: 'Application (Project Title)',
			renderCell: (cellValues) => <TitleTooltip cellValues={cellValues} />,
			flex: columnWidths.title || 1,
			resizable: true
		},
		{
			field: 'stageName',
			headerName: 'Evaluation Stage Name',
			renderCell: (cellValues) => <StageTooltip cellValues={cellValues} />,
			flex: !columnWidths.stageName && 1,
			resizable: true
		},
		{
			field: 'status',
			headerName: 'Stage Status',
			renderCell: (cellValues) => <StatusTooltip cellValues={cellValues} />,
			flex: !columnWidths.status && 1,
			maxWidth: 175
		},
		{
			field: 'totalReviewers',
			headerName: 'Number of Reviewers',
			renderCell: (cellValues) => (
				<BasicCellText
					openTooltip={openTooltip}
					setOpenTooltip={setOpenTooltip}
					cellValues={cellValues}
				/>
			),
			flex: columnWidths.reviewer || 1,
			maxWidth: 205,
			type: 'number',
			headerAlign: 'left',
			align: 'left',
			resizable: true
		},
		{
			field: 'reviewers',
			headerName: 'Assigned Reviewers',
			renderCell: (cellValues) => <SimpleTooltip cellValues={cellValues} />,
			flex: columnWidths.reviewFormName || 1,
			resizable: true
		}
	];
};

export default BulkRevToEvalColumns;
